module.exports = __webpack_public_path__ + "img/4.7d7ea235.png";